module.exports = "<div class=\"m-trackitem\">\n  <header class=\"row\">\n    <h2>{{ vm.header }}</h2>\n  </header>\n  <section class=\"row\">\n    <p class=\"hint\">\n      {{ vm.desc }}\n    </p>\n    <trackingcode></trackingcode>\n  </section>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/static/templates/main.view.html
// module id = 10
// module chunks = 0